import Link from "next/link";
import type { ReactNode } from "react";

type Variant = "primary" | "secondary" | "dark" | "ghost" | "white";

const BASE =
  "inline-flex items-center justify-center gap-2 rounded-[8px] font-extrabold leading-none transition-all duration-150 px-[18px] py-3 text-[15px] min-h-[46px] cursor-pointer hover:-translate-y-px";

const VARIANTS: Record<Variant, string> = {
  primary:
    "bg-action text-white shadow-[0_12px_24px_rgba(22,138,91,.22)] hover:bg-action-dark hover:shadow-[0_16px_30px_rgba(22,138,91,.27)]",
  secondary: "bg-surface border border-line text-ink hover:border-[#bdc8d1] hover:shadow-soft",
  dark: "bg-ink text-white hover:bg-ink-2",
  ghost: "border border-line bg-transparent text-ink hover:border-[#bdc8d1] hover:bg-surface",
  white: "bg-white text-ink hover:bg-white/90",
};

export function Button({
  href,
  children,
  variant = "primary",
  className = "",
  trackClick,
  newTab,
}: {
  href: string;
  children: ReactNode;
  variant?: Variant;
  className?: string;
  trackClick?: string;
  newTab?: boolean;
}) {
  const cls = `${BASE} ${VARIANTS[variant]} ${className}`;
  const external = href.startsWith("http") || href.startsWith("mailto:") || href.startsWith("#");
  const data = trackClick ? { "data-track": trackClick } : {};
  if (external) {
    return (
      <a href={href} className={cls} {...(newTab ? { target: "_blank", rel: "noopener" } : {})} {...data}>
        {children}
      </a>
    );
  }
  return (
    <Link href={href} className={cls} {...data}>
      {children}
    </Link>
  );
}
